// extracted by mini-css-extract-plugin
export default {"container":"About_container__BF4oA","heading":"About_heading__LQSGY","cards":"About_cards__-zhjB"};